import CookieHelper from "./cookieHelper";
import API_CONFIG from "../config/apiConstant";
import logger from "./logger";

// Store token + user in cookie + localStorage
export const handleJwt = (data) => {
    if (!data?.token) {
        logger.error("Token not found in data");
        throw new Error("Token not found");
    }

    try {
    logger.debug("Handling JWT token storage", data.userName || 'user');
        const cookieHelper = new CookieHelper();

        // Store full user object in cookie
        cookieHelper.setUserCookie(data);

            // Also store in localStorage for consistency
        localStorage.setItem(API_CONFIG.STORAGE_KEYS.USER, JSON.stringify(data));
        localStorage.setItem(API_CONFIG.STORAGE_KEYS.ACCESS_TOKEN, data.token);

        logger.info("JWT stored successfully!");
    } catch (error) {
        logger.error("Error storing JWT:", error);
        throw error;
    }
};

// Remove token + user (logout)
export const clearJwt = () => {
  try {
    logger.info("Clearing JWT tokens");
    const cookieHelper = new CookieHelper();
    
    // Clear cookies
    cookieHelper.clearAllCookies();
    
    // Clear localStorage
    localStorage.removeItem(API_CONFIG.STORAGE_KEYS.USER);
    localStorage.removeItem(API_CONFIG.STORAGE_KEYS.ACCESS_TOKEN);
    
    logger.info("JWT tokens cleared successfully");
  } catch (error) {
    logger.error("Error clearing JWT:", error);
  }
};

// Get token (cookie → fallback to localStorage)
export const getJwtToken = () => {
  try {
    const cookieHelper = new CookieHelper();
    const userData = cookieHelper.getUserCookie();
    
    if (userData && userData.token) {
      return userData.token;
    }
    
    // Fallback to localStorage
    return localStorage.getItem(API_CONFIG.STORAGE_KEYS.ACCESS_TOKEN);
  } catch (error) {
    logger.error("Error getting JWT token:", error);
    return null;
  }
};

// Validate if JWT is expired
export const isTokenValid = () => {
  const token = getJwtToken();
  
  if (!token) {
    return false;
  }
  
  try {
    // Basic token validation (you can enhance this based on your token structure)
    const tokenParts = token.split('.');
    if (tokenParts.length !== 3) {
      return false;
    }
    
    // Decode the payload (base64)
    const payload = JSON.parse(atob(tokenParts[1]));
    
    // Check if token is expired
    if (payload.exp && Date.now() >= payload.exp * 1000) {
      logger.info("Token is expired");
      return false;
    }
    
    return true;
  } catch (error) {
    logger.error("Error validating token:", error);
    return false;
  }
};